

















export default {
    name: 'EventCardLabel',
    functional: true,
    props: {
        isLive: {
            type: Boolean,
            default: false,
        },
        isBold: {
            type: Boolean,
            default: false,
        },
        isTextDarker: {
            type: Boolean,
            default: false,
        },
    },
};
